﻿import { addCommands, clearCommands } from './commands';
import { commandFactory } from './factory';

let { cuiCommands } = window;
if (!cuiCommands) {
	const commandsWindow = window.aras
		? window.aras.getMostTopWindowWithAras()
		: window;
	const { cuiCommands: topWindowCuiCommands } = commandsWindow;

	cuiCommands = topWindowCuiCommands ?? {
		addCommands,
		clearCommands,
		commandFactory
	};

	window.cuiCommands = cuiCommands;
}

export default cuiCommands;
